export default __webpack_public_path__ + "static/plate-3960d9712428b712e6c06efb9672b105.png";